module.exports = __webpack_public_path__ + "img/night.c3d2d267.svg";